import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58c80c26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opinion-container" }
const _hoisted_2 = { class: "opinion-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "no-survey-exist"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("죄송합니다. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("설문 내용을 불러오는데 실패하였습니다.")
], -1 /* HOISTED */))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "opinion-reason"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "section-label" }
const _hoisted_10 = { class: "reasons" }
const _hoisted_11 = ["id", "name", "type", "value", "onClick"]
const _hoisted_12 = { class: "radio-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavigationBar"], {
      title: "의견 남기기",
      shouldHideBackButton: true,
      shouldShowUnderline: true,
      onOnClickClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClickClose')))
    }),
    _createElementVNode("div", _hoisted_2, [
      (!$setup.complaintsSurvey)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [..._hoisted_5]))
        : (_openBlock(), _createElementBlock("section", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.complaintsSurvey?.questions, (question) => {
              return (_openBlock(), _createElementBlock("div", {
                key: question.order
              }, [
                (question.answerType === 'text')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode($setup["BaseTextarea"], {
                        id: `textArea${question.order}`,
                        cols: 30,
                        rows: 6,
                        maxlength: question.maxLength,
                        placeholder: question.placeholder,
                        getTextAreaLength: $setup.getTextAreaLength(question.order),
                        onOnInput: ($event: any) => ($setup.updateTextAreaAnswer(question.order, $event)),
                        onOnFocus: ($event: any) => ($setup.focusRadioInput(question.order))
                      }, null, 8 /* PROPS */, ["id", "maxlength", "placeholder", "getTextAreaLength", "onOnInput", "onOnFocus"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("p", _hoisted_9, _toDisplayString(question.title), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "radio-wrapper",
                            key: answer.id
                          }, [
                            _createElementVNode("input", {
                              id: $setup.getRadioButtonId(question.order, answer.id),
                              class: "input-radio",
                              name: question.title,
                              type: question.answerType,
                              value: answer.id,
                              onClick: ($event: any) => ($setup.onClickRadioButton(answer.id, question))
                            }, null, 8 /* PROPS */, _hoisted_11),
                            _createElementVNode("label", _hoisted_12, _toDisplayString(answer.title), 1 /* TEXT */)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]))
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
    ]),
    _createVNode($setup["FooterButton"], {
      title: "의견 남기기",
      disabled: !$setup.isComplete,
      onOnClickFooterButton: $setup.onClickFooterButton
    }, null, 8 /* PROPS */, ["disabled"])
  ]))
}